const DEFAULT_CELL_PADDING = 20;

const getTextWidth = (text: string) => {
    const span = document.createElement('span');

    span.style.font =
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif';
    span.style.fontSize = '14px';
    span.style.whiteSpace = 'nowrap';
    span.textContent = text;

    document.body.appendChild(span);
    const width = span.offsetWidth;

    document.body.removeChild(span);

    return width;
};

export const checkIsTooltipActive = (textValue: string | number, actualCellWidth: number) => {
    const textWidth = getTextWidth(textValue.toString());
    const cellWidth = actualCellWidth - DEFAULT_CELL_PADDING * 2;

    return (textWidth ?? 0) > cellWidth;
};
